import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { type Picture } from '@/types/photo-uploader';
import { messageSend } from '@/js/lib/api/message';
import { useUserStore } from '@/js/lib/store/user';
import { credentials } from '@/js/lib/api/user';
import { info, loading } from '@/js/lib/ui';
import { confirm } from '@/js/lib/ui/confirm';
import { signinSignup } from '@/js/lib/ui/signin-signup';
import IButton from '@/js/components/molecules/IButton.vue';
import IModal from '@/js/components/molecules/IModal.vue';
import IMenu from '@/js/components/molecules/IMenu.vue';
import ITextArea from '@/js/components/molecules/ITextArea.vue';
import ITextField from '@/js/components/molecules/ITextField.vue';
import PhotoUploader from '@/js/components/common/ui/form/photo-uploader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageButton',
  props: {
    disabled: { type: Boolean },
    itemId: { default: 0 },
    shopId: null,
    subject: { default: '' }
  },
  setup(__props: any) {

const props = __props as { disabled?: boolean, itemId: number, shopId: number, subject: string };


const userStore = useUserStore();
const observer = ref();
const isShowMessageDialog = ref(false);
const isShowImageNote = ref(false);
const subjectStr = ref(props.subject);
const messageStr = ref(props.itemId ? `\n\n${window.location.href.replace(window.location.search, '').replace(window.location.hash, '')}` : '');
const pictures = ref<Picture[]>([]);
const onClick = () => {
  if (userStore.isAuthenticated) {
    if (userStore.hasCredential(credentials.emailConfirmed)) {
      isShowMessageDialog.value = true;
    } else {
      info('メッセージを送信するにはメール認証が必要です。\n「マイページ > 設定 > ログイン情報 > メールアドレスの変更」よりメール認証を行ってください。');
    }
  } else {
    signinSignup({
      next: window.location.href,
      callback: () => {
        window.location.reload();
      },
    });
  }
};
const onSubmit = async () => {
  const isValid = await observer.value.validate();
  if (!isValid) {
    return;
  }
  if (await confirm('メッセージを送信します。\nよろしいですか？')) {
    loading({
      asyncFunc: async () => {
        await messageSend({
          shopId: props.shopId,
          itemId: props.itemId,
          picture: pictures.value[0],
          subject: subjectStr.value,
          message: messageStr.value,
        });
        await info('メッセージを送信しました。', { fadeOut: true });
        window.location.reload();
      },
    });
  }
};

return { __sfc: true,props, userStore, observer, isShowMessageDialog, isShowImageNote, subjectStr, messageStr, pictures, onClick, onSubmit, IButton, IModal, IMenu, ITextArea, ITextField, PhotoUploader }
}

})